
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMicGoogle as ObiComMicGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-mic-google.js';
 
 
 

 
 export const ObiComMicGoogle = createComponent({
   react: React,
   tagName: 'obi-com-mic-google',
   elementClass: ObiComMicGoogleElement,
   events: {
     
   }
  });
 
 